import { toPlain } from '@/core/utils/object-util';

function toUTC(date) {
    const utc = new Date(date);
    utc.setUTCFullYear(utc.getFullYear(), utc.getMonth(), utc.getDate());
    utc.setUTCHours(utc.getUTCHours(), utc.getUTCMinutes(), utc.getUTCSeconds());
    return utc;
}

function toDayStr(date) {
    return toUTC(date).toJSON().substr(0, 10);
}

export const Sanitize = {
    trim: value => (value ? value.trim() : value),
    date: date => new Date(date),
    utcDate: toUTC,
    toDayStr,
    round: digits => value => +Number(value).toFixed(digits),
    select: (fieldName = 'value') => obj => obj && obj[fieldName],
    number: value => Number(value),
    // eslint-disable-next-line no-use-before-define
    array: sanitizeArray,
    money: value => +Number(value).toFixed(2),
};

export function sanitize(model, rules) {
    const values = toPlain(model);
    Object.entries(rules || {}).forEach(([key, actions]) => {
        actions.forEach((action) => {
            const func = (action && action.sanitize) || action;
            if (typeof func === 'function') {
                values[key] = action(values[key]);
            }
        });
    });
    return values;
}

export function syncField(name) {
    return {
        get() {
            return this[name];
        },
        set(val) {
            this.$emit(`update:${name}`, val);
        },
    };
}


export function sanitizeArray(rules) {
    return list => list.map(model => sanitize(model, rules));
}

export default { sanitize, syncField };
